export default __webpack_public_path__ + "static/media/open-contests.24577f9b.svg";